import { loadModelFromPath } from '../modelLoader.js';

export async function loadModel(context, file, isDefault = false, onProgress = null) {
    if (!file && !isDefault) return;
    try { 
        context.updateStatus(isDefault ? 'Loading default model...' : 'Loading model...');
        let url;
        
        if (isDefault) {
            // Load default model with progress
            const modelPath = new URL('/mesh/Letuka_head_Tattooi.obj', import.meta.url).href;
            const response = await fetch(modelPath);
            if (!response.ok) {
                throw new Error(`Failed to load default model: ${response.statusText}`);
            }
            
            const contentLength = response.headers.get('content-length');
            let loaded = 0;
            const reader = response.body.getReader();
            const chunks = [];
            
            while (true) {
                const { done, value } = await reader.read();
                if (done) break;
                
                chunks.push(value);
                loaded += value.length;
                
                if (onProgress && contentLength) {
                    const progress = Math.round((loaded / contentLength) * 100);
                    onProgress(progress);
                }
            }
            
            const blob = new Blob(chunks);
            url = URL.createObjectURL(blob);
        } else {
            // Load user-provided model with progress
            url = URL.createObjectURL(file);
            
            if (onProgress) {
                const reader = new FileReader();
                reader.onprogress = (e) => {
                    if (e.lengthComputable) {
                        const progress = Math.round((e.loaded / e.total) * 100);
                        onProgress(progress);
                    }
                };
                await new Promise((resolve) => {
                    reader.onload = resolve;
                    reader.readAsArrayBuffer(file);
                });
            }
        }
        
        await loadModelFromPath(context, url);
        if (!isDefault) URL.revokeObjectURL(url);

        if (isDefault) {
            context.isDefaultMesh = true;
            context.udimNameMap = { 1001: 'Head', 1002: 'Upper Body', 1003: 'Lower Body', 1004: 'Ears' };
        } else {
            context.isDefaultMesh = false;
            if (context.udimNameMap && context.udimNameMap.__source === 'default') {
                context.udimNameMap = null;
            }
        }

        context.updateStatus(isDefault ? 'Default model loaded successfully' : 'Model loaded successfully');
    }
    catch (error) { 
        console.error('Error loading model:', error); 
        context.updateStatus('Error loading model'); 
    }
}

export async function loadDefaultModel(context) {
    return loadModel(context, null, true);
}
